<!--This component is used to display a loader for a text part-->
<p class="vtmn-animate-pulse vtmn-bg-grey-light-2 vtmn-h-2 vtmn-w-full" />
